import { render, staticRenderFns } from "./VideoOrderList.vue?vue&type=template&id=2cff91fa&scoped=true"
import script from "./VideoOrderList.vue?vue&type=script&lang=js"
export * from "./VideoOrderList.vue?vue&type=script&lang=js"
import style0 from "./VideoOrderList.vue?vue&type=style&index=0&id=2cff91fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff91fa",
  null
  
)

export default component.exports